
import { Component } from '@niknevis/vue-modules'
import AdminDepartmentBaseForm from '@/modules/department/components/admin/base/AdminDepartmentBaseForm.vue'
import { AdminDepartmentUpdateUseCase } from '@/modules/department/use-cases/admin-department-update.use-case'
import { Prop } from 'vue-property-decorator'
import { DepartmentResourceModel } from '@/modules/department/models/department-resource.model'
import { DepartmentRequestModel } from '@/modules/department/models/department-request.model'

@Component
export default class AdminDepartmentEditForm extends AdminDepartmentBaseForm {
  constructor(
    private readonly useCase: AdminDepartmentUpdateUseCase
  ) {
    super()
  }

  @Prop({ required: true }) departmentResource: DepartmentResourceModel

  protected telegramActivationCode: string = this.departmentResource.telegram_activation_code

  protected supporterSearchDefault: number[] = this.departmentResource.supporters.map(supporter => supporter.id)

  protected requestData: DepartmentRequestModel = {
    active: this.departmentResource.active,
    auto_message: this.departmentResource.auto_message,
    chat_id: this.departmentResource.chat_id,
    contactable: this.departmentResource.contactable,
    description: this.departmentResource.description,
    send_auto_message: this.departmentResource.send_auto_message,
    supporters: this.supporterSearchDefault,
    title: this.departmentResource.title
  }

  protected get loadingState(): boolean {
    return this.loading || this.__loadingState || this.useCase.isLoading
  }

  protected onSubmit() {
    this.useCase.execute(this.departmentResource.id, this.requestData)
  }
}
